import { useLingui } from "@lingui/react/macro";
import { DialogPanel } from "@medoma/components/DialogPanel/DialogPanel";
import { ActivityOccurrence } from "@/pages/commandcenter/Patients/Patient/Activities/ActivityOccurrence/ActivityOccurrence";
import { useNavigate, useParams } from "react-router";
import { z } from "zod";

export const ActivityOccurrenceDialog = ({
  redirectPathRelativeToCenterRootOnClose,
}: {
  redirectPathRelativeToCenterRootOnClose: string;
}) => {
  const { t } = useLingui();
  const navigate = useNavigate();
  const { activityId, occurrenceId } = z
    .object({ activityId: z.string(), occurrenceId: z.string() })
    .parse(useParams());

  const onClose = () => {
    void navigate(`/commandcenter/${redirectPathRelativeToCenterRootOnClose}`);
  };

  return (
    <DialogPanel
      isOpen={true}
      width="fixed"
      onClose={onClose}
      title={t`Aktivitetsdetaljer`}
      hideTitle
    >
      <ActivityOccurrence
        activityId={activityId}
        occurrenceId={occurrenceId}
        closeActivityOccurrencePanel={onClose}
      />
    </DialogPanel>
  );
};
